import { GET_PLANT_LIST, LOADING_PLANT_LIST, CHANGE_SEARCH_QUERY, RESET_SEARCH_PLANT, RESET_FILTERED_PLANTS } from '../actions'

const INITIAL_STATE = {
    page: 1,
    query: '',
    isLoading: false,
    isLast: false,
    plants: [],
}

function PlantListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOADING_PLANT_LIST:
            return {
                ...state,
                isLoading: true,
            }
        case GET_PLANT_LIST:
            return {
                ...state,
                plants: action.meta.searchQuery !== state.query
                    ? action.payload.body.plants
                    : [...state.plants, ...action.payload.body.plants],
                isLast: action.payload.body.last,
                isLoading: false,
                page: state.page + 1,
            }
        case CHANGE_SEARCH_QUERY:
            return {
                ...state,
                query: action.payload,
                isLoading: true,
                plants: [],
                page: 1,
            }
        case RESET_SEARCH_PLANT:
            return {
                ...INITIAL_STATE,
                isLoading: true,
            }
        case RESET_FILTERED_PLANTS:
            return {
                ...INITIAL_STATE,
                isLoading: true,
                query: state.query,
            }
        default: return state
    }
}

export default PlantListReducer



// WEBPACK FOOTER //
// ./src/reducers/plantList.js